<template>
    <div class="view-and-compare-your-shortlisted-vehicles-component">

        <div class="container-fluid">
            <div class="row">
                <div class="col-8">
                    <h1>View & Compare Your Shortlisted Vehicles</h1>
                    <p>This page is where your can compare your shortlisted vehicles side by side. Use the scroll bars to move between vehicles in your shortlists and compare the right options for you. The MPG slider allows you to amend the value based on your driving style, this will vary you fuel costs and help you view the real world cost implication of your selections. The figures shown provide a breakdown of the estimated costs for you to run the vehicle, resulting in a Total Monthly Net Cost (estimated). You can add options and further configure your quote by clicking on ‘CONFIGURE’. Please view the information boxes throughout this page which are provided to give you more detail in relevant sections. Once you have made your selection, click on ‘ORDER SELECTED CAR’ to continue.</p>
                </div>
                <div class="col-4 d-flex flex-row justify-content-end">
                    <div class="jump-to">
                        <div class="select">
                            <select id="jump-to" name="jump-to">
                                <option>Jump to Vehicle</option>
                                <optgroup>
                                    <option>Option One</option>
                                    <option>Option Two</option>
                                    <option>Option Three</option>
                                </optgroup>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div :class="sideBySide ? 'col-6' : 'col-12'">
                    <div class="shortlist-items">
                        <div>
                            <div class="shortlist-scheme">
                                <div class="jump-to">
                                    <div class="select large ms-0">
                                        <select class="large">
                                            <option>Your Essential Business Scheme shortlist</option>
                                            <optgroup>
                                                <option>Option One</option>
                                                <option>Option Two</option>
                                                <option>Option Three</option>
                                            </optgroup>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="shortlist-item shortlist-item--small">
                                <ul>
                                    <li class="make-and-model"><span>BMW</span> <span>3 SERIES</span></li>
                                    <li class="monthly-new-cost"><span>Monthly Net Cost</span> <span>£458.08</span></li>
                                </ul>
                            </div>
                            <div class="shortlist-item shortlist-item--large">
                                <div class="row">
                                    <div class="col-4" :class="sideBySide === true ? 'col-6' : 'col-4'">
                                        <div class="column-one">

                                            <ul class="ul-column">
                                                <li class="make-and-model"><span class="key">BMW 2 Series</span></li>
                                                <li class="description"><span class="key">DIESEL SALOON 320d M Sport 4dr Step Auto</span></li>
                                                <li class="quote-ref"><span class="key">Quote Ref:</span> <span class="value">CC305967x</span></li>
                                                <li class="quote-name"><span class="key">My Custom Grey 3 Series</span></li>
                                            </ul>

                                            <ul class="ul-row">
                                                <li class="contract-term"><span class="key">Contract Term</span><span class="value">36 Months</span></li>
                                                <li class="total-mileage"><span class="key">Total Mileage</span><span class="value">90,000</span></li>
                                            </ul>

                                            <img src="/images/audi@2x.png" alt="">

                                            <mpg-slider v-if="sideBySide === true" quote="1000" default-mpg="500"></mpg-slider>

                                            <div v-if="sideBySide === true">
                                                <ul class="ul-additional">
                                                    <li class="mpg-combined"><span class="key">MPG (Combined)</span><span class="value">66.0</span></li>
                                                    <li class="electric-range-combined"><span class="key">Electric Range (Combined)</span><span class="value">36 miles</span></li>
                                                    <li class="p11d-value"><span class="key">P11d Value</span><span class="value">£37,210</span></li>
                                                    <li class="c02-combined"><span class="key">C02 (Combined)</span><span class="value">113g/km</span></li>
                                                    <li class="engine-size"><span class="key">Engine Size</span><span class="value">1995cc</span></li>
                                                    <li class="transmission"><span class="key">Transmission</span><span class="value">Automatic</span></li>
                                                    <li class="fuel-type"><span class="key">Fuel Type</span><span class="value">Diesel</span></li>
                                                </ul>
                                            </div>

                                        </div>
                                    </div>
                                    <div v-if="sideBySide === false" class="col-4">
                                        <div class="column-two">

                                            <mpg-slider quote="1000" default-mpg="500"></mpg-slider>

                                            <ul>
                                                <li class="mpg-combined"><span class="key">MPG (Combined)</span><span class="value">66.0</span></li>
                                                <li class="electric-range-combined"><span class="key">Electric Range (Combined)</span><span class="value">36 miles</span></li>
                                                <li class="p11d-value"><span class="key">P11d Value</span><span class="value">£37,210</span></li>
                                                <li class="c02-combined"><span class="key">C02 (Combined)</span><span class="value">113g/km</span></li>
                                                <li class="engine-size"><span class="key">Engine Size</span><span class="value">1995cc</span></li>
                                                <li class="transmission"><span class="key">Transmission</span><span class="value">Automatic</span></li>
                                                <li class="fuel-type"><span class="key">Fuel Type</span><span class="value">Diesel</span></li>
                                            </ul>

                                            <p class="equivalent-company-car">Equivalent Company Car</p>

                                            <ul>
                                                <li class="total-monthly-net-cost">
                                                    <span class="key">Total Monthly Net Cost
                                                        <VDropdown :disabled="!tooltip">
                                                            <button class="tooltip-button"><i class="icon-info-solid" /></button>
                                                            <template #popper>
                                                                <h3>Total Monthly Net Cost</h3>
                                                                <p>Content Here</p>
                                                            </template>
                                                        </VDropdown>
                                                    </span>
                                                    <span class="value">£520.23</span>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                    <div class="col-4 background" :class="sideBySide === true ? 'col-6' : 'col-4'">
                                        <div class="column-three">

                                            <button class="remove"><i class="icon-cross"></i> <span>Remove</span></button>

                                            <ul>
                                                <li class="monthly-vehicle-payment"><span class="key">Monthly Vehicle Payment</span><span class="value">£807.58</span></li>
                                                <li class="insurance-product"><span class="key">Insurance Product</span><span class="value">£75.00</span></li>
                                                <li class="business-fuel-cost"><span class="key">Business Fuel Cost</span><span class="value">£152.00</span></li>
                                                <li class="total-motoring-expenses"><span class="key">Total Motoring Expenses</span><span class="value">£1,034.58</span></li>
                                            </ul>

                                            <p class="motoring-expenses">The Motoring Expenses are funded by the below amounts:</p>

                                            <ul>
                                                <li class="business-fuel-reimbursement"><span class="key">Business Fuel Reimbursement</span><span class="value">-£550.00</span></li>
                                                <li class="cost-allowance-net"><span class="key">Cash Allowance - Net</span><span class="value">-£116.00</span></li>
                                                <li class="your-contribution-estimated"><span class="key">Your Contribution - Estimated</span><span class="value">-£368.58</span></li>
                                                <li class="total-monthly-net-cost"><span class="key">Total Monthly Net Cost</span><span class="value">£1,034.58</span></li>
                                                <li class="private-fuel-cost"><span class="key">Private Fuel Cost</span><span class="value">£76.00</span></li>
                                                <li class="optional-final-balloon-payment"><span class="key">Optional Final Balloon Payment</span><span class="value">£7813.75</span></li>
                                            </ul>

                                            <p v-if="sideBySide === true" class="equivalent-company-car-additional">Equivalent Company Car</p>

                                            <ul v-if="sideBySide === true">
                                                <li class="total-monthly-net-cost-additional">
                                                    <span class="key">Total Monthly Net Cost
                                                        <VDropdown :disabled="!tooltip">
                                                            <button class="tooltip-button"><i class="icon-info-solid" /></button>
                                                            <template #popper>
                                                                <h3>Total Monthly Net Cost</h3>
                                                                <p>Content Here</p>
                                                            </template>
                                                        </VDropdown>
                                                    </span>
                                                    <span class="value">£520.23</span>
                                                </li>
                                            </ul>

                                            <ul class="actions">
                                                <li>
                                                    <button class="button button--charcoal-ghost button--small">Configure</button>
                                                </li>
                                                <li>
                                                    <button class="button button--charcoal button--small">Select</button>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="shortlist-item shortlist-item--small last">
                                <ul>
                                    <li class="make-and-model"><span>BMW</span> <span>3 SERIES</span></li>
                                    <li class="monthly-new-cost"><span>Monthly Net Cost</span> <span>£458.08</span></li>
                                </ul>
                            </div>
                        </div>
                        <div>
                            <div class="shortlist-controls">
                                <ul class="controls">
                                    <li class="controls__previous">
                                        <button><i class="icon-arrow-right-1"></i></button>
                                    </li>
                                    <li class="controls__count">1/10</li>
                                    <li class="controls__next">
                                        <button><i class="icon-arrow-right-1"></i></button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="sideBySide" :class="sideBySide ? 'col-6' : 'col-12'">
                    <div class="shortlist-items">
                        <div>
                            <div class="shortlist-scheme">
                                <div class="jump-to">
                                    <div class="select large ms-0">
                                        <select class="large">
                                            <option>Your Essential Business Scheme shortlist</option>
                                            <optgroup>
                                                <option>Option One</option>
                                                <option>Option Two</option>
                                                <option>Option Three</option>
                                            </optgroup>
                                        </select>
                                    </div>
                                </div>
                                <button @click="sideBySide = !sideBySide">Remove Column</button>
                            </div>
                            <div class="shortlist-item shortlist-item--small">
                                <ul>
                                    <li class="make-and-model"><span>BMW</span> <span>3 SERIES</span></li>
                                    <li class="monthly-new-cost"><span>Monthly Net Cost</span> <span>£458.08</span></li>
                                </ul>
                            </div>
                            <div class="shortlist-item shortlist-item--large">
                                <div class="row">
                                    <div class="col-4" :class="sideBySide === true ? 'col-6' : 'col-4'">
                                        <div class="column-one">
                                            <ul class="ul-column">
                                                <li class="make-and-model"><span class="key">BMW 2 Series</span></li>
                                                <li class="description"><span class="key">DIESEL SALOON 320d M Sport 4dr Step Auto</span></li>
                                                <li class="quote-ref"><span class="key">Quote Ref:</span> <span class="value">CC305967x</span></li>
                                                <li class="quote-name"><span class="key">My Custom Grey 3 Series</span></li>
                                            </ul>
                                            <ul class="ul-row">
                                                <li class="contract-term"><span class="key">Contract Term</span><span class="value">36 Months</span></li>
                                                <li class="total-mileage"><span class="key">Total Mileage</span><span class="value">90,000</span></li>
                                            </ul>
                                            <img src="/images/audi@2x.png" alt="">
                                            <mpg-slider v-if="sideBySide === true" quote="1000" default-mpg="500"></mpg-slider>
                                            <div v-if="sideBySide === true">
                                                <ul class="ul-additional">
                                                    <li class="mpg-combined"><span class="key">MPG (Combined)</span><span class="value">66.0</span></li>
                                                    <li class="electric-range-combined"><span class="key">Electric Range (Combined)</span><span class="value">36 miles</span></li>
                                                    <li class="p11d-value"><span class="key">P11d Value</span><span class="value">£37,210</span></li>
                                                    <li class="c02-combined"><span class="key">C02 (Combined)</span><span class="value">113g/km</span></li>
                                                    <li class="engine-size"><span class="key">Engine Size</span><span class="value">1995cc</span></li>
                                                    <li class="transmission"><span class="key">Transmission</span><span class="value">Automatic</span></li>
                                                    <li class="fuel-type"><span class="key">Fuel Type</span><span class="value">Diesel</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="sideBySide === false" class="col-4">
                                        <div class="column-two">
                                            <ul>
                                                <li class="mpg-combined"><span class="key">MPG (Combined)</span><span class="value">66.0</span></li>
                                                <li class="electric-range-combined"><span class="key">Electric Range (Combined)</span><span class="value">36 miles</span></li>
                                                <li class="p11d-value"><span class="key">P11d Value</span><span class="value">£37,210</span></li>
                                                <li class="c02-combined"><span class="key">C02 (Combined)</span><span class="value">113g/km</span></li>
                                                <li class="engine-size"><span class="key">Engine Size</span><span class="value">1995cc</span></li>
                                                <li class="transmission"><span class="key">Transmission</span><span class="value">Automatic</span></li>
                                                <li class="fuel-type"><span class="key">Fuel Type</span><span class="value">Diesel</span></li>
                                            </ul>
                                            <p class="equivalent-company-car">Equivalent Company Car</p>
                                            <ul>
                                                <li class="total-monthly-net-cost"><span class="key">Total Monthly Net Cost</span><span class="value">£520.23</span></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="background" :class="sideBySide === true ? 'col-6' : 'col-4'">
                                        <div class="column-three">

                                            <button class="remove"><i class="icon-cross"></i> <span>Remove</span></button>

                                            <ul>
                                                <li class="monthly-vehicle-payment"><span class="key">Monthly Vehicle Payment</span><span class="value">£807.58</span></li>
                                                <li class="insurance-product"><span class="key">Insurance Product</span><span class="value">£75.00</span></li>
                                                <li class="business-fuel-cost"><span class="key">Business Fuel Cost</span><span class="value">£152.00</span></li>
                                                <li class="total-motoring-expenses"><span class="key">Total Motoring Expenses</span><span class="value">£1,034.58</span></li>
                                            </ul>
                                            <p class="motoring-expenses">The Motoring Expenses are funded by the below amounts:</p>
                                            <ul>
                                                <li class="business-fuel-reimbursement"><span class="key">Business Fuel Reimbursement</span><span class="value">-£550.00</span></li>
                                                <li class="cost-allowance-net"><span class="key">Cash Allowance - Net</span><span class="value">-£116.00</span></li>
                                                <li class="your-contribution-estimated"><span class="key">Your Contribution - Estimated</span><span class="value">-£368.58</span></li>
                                                <li class="total-monthly-net-cost"><span class="key">Total Monthly Net Cost</span><span class="value">£1,034.58</span></li>
                                                <li class="private-fuel-cost"><span class="key">Private Fuel Cost</span><span class="value">£76.00</span></li>
                                                <li class="optional-final-balloon-payment"><span class="key">Optional Final Balloon Payment</span><span class="value">£7813.75</span></li>
                                            </ul>

                                            <p v-if="sideBySide === true" class="equivalent-company-car-additional">Equivalent Company Car</p>

                                            <ul v-if="sideBySide === true">
                                                <li class="total-monthly-net-cost-additional">
                                                    <span class="key">Total Monthly Net Cost
                                                        <VDropdown :disabled="!tooltip">
                                                            <button class="tooltip-button"><i class="icon-info-solid" /></button>
                                                            <template #popper>
                                                                <h3>Total Monthly Net Cost</h3>
                                                                <p>Content Here</p>
                                                            </template>
                                                        </VDropdown>
                                                    </span>
                                                    <span class="value">£520.23</span>
                                                </li>
                                            </ul>

                                            <ul class="actions">
                                                <li>
                                                    <button class="button button--charcoal-ghost button--small reconfigure">Reconfigure</button>
                                                </li>
                                                <li>
                                                    <button class="button button--charcoal button--small selected">Selected</button>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="shortlist-item shortlist-item--small last">
                                <ul>
                                    <li class="make-and-model"><span>BMW</span> <span>3 SERIES</span></li>
                                    <li class="monthly-new-cost"><span>Monthly Net Cost</span> <span>£458.08</span></li>
                                </ul>
                            </div>
                        </div>
                        <div>
                            <div class="shortlist-controls">
                                <ul class="controls">
                                    <li class="controls__previous">
                                        <button><i class="icon-arrow-right-1"></i></button>
                                    </li>
                                    <li class="controls__count">1/10</li>
                                    <li class="controls__next">
                                        <button><i class="icon-arrow-right-1"></i></button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <button v-if="sideBySide === false" @click="sideBySide = !sideBySide" class="compare-side-by-side"><span>Compare side by side</span></button>
            </div>
        </div>

    </div>
</template>

<script>
import MpgSlider from "./car-comparison/mpg-slider";
export default {
    components: {MpgSlider},
    data() {
        return {
            sideBySide: false,
            tooltip: true
        };
    }
}

</script>

